import { Data2 } from '../../../features/data-types'
import { VatTaxCode } from '../../administration'
import { FiscalDocumentItem } from '../state/types'

export const useFiscalDocumentBuilders = () => {
    const buildFiscalDocumentItem = (data: Data2) => {
        const {
            name,
            unitTypeName,
            vatTaxCode,
            vatTaxYield,
            unitSubtotal,
            unitTotal,
            quantity,
            totalWithoutVAT,
            vatAmount
        } = data

        const fiscalDocumentItem: FiscalDocumentItem = {
            name: name! as string,
            unitTypeName: unitTypeName! as string,
            vatTaxCode: vatTaxCode as VatTaxCode | undefined,
            vatTaxYield: vatTaxYield! as number,
            unitSubtotal: unitSubtotal! as number,
            unitTotal: unitTotal! as number,
            quantity: quantity! as number,
            totalWithoutVAT: totalWithoutVAT! as number,
            vatAmount: vatAmount! as number,
        }

        return fiscalDocumentItem
    }

    return {
        buildFiscalDocumentItem
    }
}
